import { render, staticRenderFns } from "./Aliados.vue?vue&type=template&id=0edcd0d6&scoped=true"
import script from "./Aliados.vue?vue&type=script&lang=js"
export * from "./Aliados.vue?vue&type=script&lang=js"
import style0 from "./Aliados.vue?vue&type=style&index=0&id=0edcd0d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edcd0d6",
  null
  
)

export default component.exports